import { ReactComponent as ResetSvg } from '../../assets/icons/reset.svg';

export const ResetIcon: SvgIcon = (props) => {
    return <ResetSvg {...props} />;
};
